import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Store from 'store';

import YMContextProvider from 'YM/Context';

import GTM from 'components/GTM';
import Layout from 'components/Layout';

import 'static/scss/common.scss';

const App: FC = () => {
    return (
        <>
            <GTM />
            <YMContextProvider>
                <Store>
                    <Layout>
                        <Outlet />
                    </Layout>
                </Store>
            </YMContextProvider>
        </>
    );
};

export default App;
